'use strict';

angular.module('cgmemApp')
  .controller('AdminSummaryCtrl', function ($scope, $rootScope, $http, $q, $log, WorkingAccount, AppConfig) {
		$scope.loaded = false;
		
		var r0 = $http.get('/api/reports/accountsBySMS');
 		var r1 = $http.get('/api/reports/purchases');
		var r2 = $http.get('/api/reports/transsum');
		var r3 = $http.get('/api/reports/balancesum');
		$scope.appConfig = {};
		
		$q.all([r0,r1,r2,r3, AppConfig.get()])
		.then(function(d) {
			$scope.sms = d[0].data;
			$scope.purchases = d[1].data;
			$scope.transsum = d[2].data;
			$scope.balancesum = d[3].data;
			$scope.appConfig = d[4];

			$scope.transFlat = {
				purchase: 0,
				reversal: 0,
				ccpayment: 0,
				ccrefund: 0,
				checkpayment: 0,
				checkrefund: 0,
				cashpayment: 0,
				cashrefund: 0,
				balanceAdjustment: 0,
				accountTypeAdjustment: 0
			}
			d[2].data.forEach(e => $scope.transFlat[e._id] = e.total);
		})
		.catch(function(err) {
			$log.log(err)
			$rootScope.$emit('generalAlert',"Error retrieving reports", err.message || err.data || err.statusText);
		})
		.finally(function() {
			$scope.loaded = true;
		});
		
  });
